/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';

// eslint-disable-next-line arrow-parens
const AltMapBackgroundDots = dots => {
  const nodes = [];
  let i = 0;
  for (i; i < dots; i += 1) {
    nodes.push(<div className="dot" key={uniqid()} />);
  }
  return nodes;
};

const AltMapProps = {
  label: PropTypes.string.isRequired, // Friendly message to display to the user
};

const AltMapDefaultProps = {};

const AltMap = ({ label }) => (
  <div className="google-map">
    <div className="alt-map">
      <input type="checkbox" id="bars" className="bars" />
      <label className="janet janet__bars" htmlFor="bars" />
      <h1 className="hidden">{label}</h1>
      <div className="cloud">
        <div className="cluster">
          {AltMapBackgroundDots(150).map(node => node)}
        </div>
      </div>
    </div>
  </div>
);

AltMap.propTypes = AltMapProps;

AltMap.defaultProps = AltMapDefaultProps;

export default AltMap;
